import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorService } from '../error/error.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { ServiceSearchResults } from 'src/app/shared/models/services/serviceSearchResults';
import { Service } from 'src/app/shared/models/services/service';

@Injectable({
    providedIn: 'root'
})
export class ServicesApiService extends ApiBaseService {

    baseUrl = environment.backend_host + '/api/services';

    constructor(
        public http: HttpClient,
        protected errorService: ErrorService,
        protected spinner: NgxSpinnerService) {
        super(spinner, errorService);
    }

    /***********************
    // SERVICES
    /***********************/
    public getAllServices = (params: SearchParams): Observable<ServiceSearchResults> => {
        const p = this.serializeParamsObj(params, new HttpParams());
        return this.http.get<any>(`${this.baseUrl}/`, { params: p })
            .pipe(map(this.deserializeAs(ServiceSearchResults)));
    }

    public getService = (id: number): Observable<Service> => {
        return this.http.get<any>(`${this.baseUrl}/${id}`)
            .pipe(map(this.deserializeAs(Service)));
    }

    public createService = (service: Service): Observable<Service> => {
        return this.http.post<any>(`${this.baseUrl}/`, this.serialize(service))
            .pipe(map(this.deserializeAs(Service)));
    }

    public updateService = (service: Service): Observable<Service> => {
        return this.http.put<any>(`${this.baseUrl}/${service.id}`, this.serialize(service))
            .pipe(map(this.deserializeAs(Service)));
    }

    public deleteService = (service: Service): Observable<any> => {
        return this.http.delete<any>(`${this.baseUrl}/${service.id}`)
            .pipe(share());
    }

    public getServicesByLayer = (params: SearchParams, layer: number): Observable<ServiceSearchResults> => {
        const p = this.serializeParamsObj(params, new HttpParams());
        return this.http.get<any>(`${this.baseUrl}/layer/${layer}`, { params: p })
            .pipe(map(this.deserializeAs(ServiceSearchResults)));
    }

    public getTimesheetTasks = (params: SearchParams): Observable<ServiceSearchResults> => {
        const p = this.serializeParamsObj(params, new HttpParams());
        return this.http.get<any>(`${this.baseUrl}/tasks`, { params: p })
            .pipe(map(this.deserializeAs(ServiceSearchResults)));
    }
}